// import type { Action, Reducer, Effect } from 'umi';
import type { Action, Reducer } from 'umi';
import type { IPayload } from '@gp/types/global';

export interface ILockerData {
  studio: {
    select_studio_id: string[];
    yoy: boolean;
    mom: boolean;
    order: 'desc' | 'asc';
    order_metric: string;
  };
  project: {
    select_project_id: string[];
    select_studio_id: string[];
    yoy: boolean;
    mom: boolean;
    order: 'desc' | 'asc';
    order_metric: string;
  };
}

type IUpdateLockerDataAction = Action<'updateLockerData'> & IPayload<any>;

interface ILockerModel {
  namespace: string;
  state: ILockerData;
  reducers: {
    updateLockerData: Reducer<ILockerData, IUpdateLockerDataAction>;
  };
  effects: {};
}

export const LOCKER_MODEL_NAMESPACE = 'dbg-model-studio-monthly-report-performance-overview-locker';

export const DEFAULT_LOCKER_DATA: ILockerData = {
  studio: {
    select_studio_id: [],
    yoy: true,
    mom: false,
    order: 'desc',
    order_metric: 'gross_revenue_monthly_actual',
  },
  project: {
    select_project_id: [],
    select_studio_id: [],
    yoy: true,
    mom: false,
    order: 'desc',
    order_metric: 'gross_revenue_monthly_actual',
  },
};

const LockerModel: ILockerModel = {
  namespace: LOCKER_MODEL_NAMESPACE,
  state: DEFAULT_LOCKER_DATA,
  reducers: {
    updateLockerData(state, action) {
      return { ...state, ...action?.payload };
    },
  },
  effects: {},
};

export default LockerModel;
